export default __webpack_public_path__ + "static/media/cash.90aca185.jpg";